var map = {
	"./api": [
		464,
		0
	],
	"./api/": [
		464,
		0
	],
	"./api/index": [
		464,
		0
	],
	"./api/index.mdx": [
		464,
		0
	],
	"./core-concepts": [
		465,
		1
	],
	"./core-concepts/": [
		465,
		1
	],
	"./core-concepts/index": [
		465,
		1
	],
	"./core-concepts/index.mdx": [
		465,
		1
	],
	"./guides/0x-api-faq": [
		1170,
		2
	],
	"./guides/0x-api-faq.mdx": [
		1170,
		2
	],
	"./guides/0x-cheat-sheet": [
		1171,
		3
	],
	"./guides/0x-cheat-sheet.mdx": [
		1171,
		3
	],
	"./guides/0x-extensions-explained": [
		1172,
		4
	],
	"./guides/0x-extensions-explained.mdx": [
		1172,
		4
	],
	"./guides/browsing-docs-on-github": [
		1173,
		5
	],
	"./guides/browsing-docs-on-github.mdx": [
		1173,
		5
	],
	"./guides/bug-bounty-program": [
		1174,
		6
	],
	"./guides/bug-bounty-program.mdx": [
		1174,
		6
	],
	"./guides/create-staking-pool": [
		1175,
		7
	],
	"./guides/create-staking-pool.mdx": [
		1175,
		7
	],
	"./guides/how-to-set-your-token-allowances": [
		1176,
		8
	],
	"./guides/how-to-set-your-token-allowances.mdx": [
		1176,
		8
	],
	"./guides/integrate-instant": [
		1177,
		9
	],
	"./guides/integrate-instant.mdx": [
		1177,
		9
	],
	"./guides/introduction-to-using-0x-liquidity-in-smart-contracts": [
		1178,
		10
	],
	"./guides/introduction-to-using-0x-liquidity-in-smart-contracts.mdx": [
		1178,
		10
	],
	"./guides/legal-guide": [
		1179,
		11
	],
	"./guides/legal-guide.mdx": [
		1179,
		11
	],
	"./guides/market-making-on-0x": [
		1180,
		12
	],
	"./guides/market-making-on-0x.mdx": [
		1180,
		12
	],
	"./guides/migrate-0x-api-from-v0-to-v1": [
		1181,
		13
	],
	"./guides/migrate-0x-api-from-v0-to-v1.mdx": [
		1181,
		13
	],
	"./guides/page-template": [
		1182,
		14
	],
	"./guides/page-template.mdx": [
		1182,
		14
	],
	"./guides/relayer-strategies": [
		1183,
		15
	],
	"./guides/relayer-strategies.mdx": [
		1183,
		15
	],
	"./guides/rfqt-in-the-0x-api": [
		1184,
		16
	],
	"./guides/rfqt-in-the-0x-api.mdx": [
		1184,
		16
	],
	"./guides/setting-up-a-local-0x-testnet": [
		1185,
		17
	],
	"./guides/setting-up-a-local-0x-testnet.mdx": [
		1185,
		17
	],
	"./guides/swap-tokens-with-0x-api": [
		1186,
		18
	],
	"./guides/swap-tokens-with-0x-api.mdx": [
		1186,
		18
	],
	"./guides/use-0x-api-liquidity-in-your-smart-contracts": [
		1187,
		19
	],
	"./guides/use-0x-api-liquidity-in-your-smart-contracts.mdx": [
		1187,
		19
	],
	"./guides/v2-coordinator-specification": [
		1188,
		20
	],
	"./guides/v2-coordinator-specification.mdx": [
		1188,
		20
	],
	"./guides/v2-forwarder-specification": [
		1189,
		21
	],
	"./guides/v2-forwarder-specification.mdx": [
		1189,
		21
	],
	"./guides/v2-specification": [
		1190,
		22
	],
	"./guides/v2-specification.mdx": [
		1190,
		22
	],
	"./guides/v3-coordinator-specification": [
		1191,
		23
	],
	"./guides/v3-coordinator-specification.mdx": [
		1191,
		23
	],
	"./guides/v3-forwarder-specification": [
		1192,
		24
	],
	"./guides/v3-forwarder-specification.mdx": [
		1192,
		24
	],
	"./guides/v3-specification": [
		1193,
		25
	],
	"./guides/v3-specification.mdx": [
		1193,
		25
	],
	"./guides/v3-staking-specification": [
		1194,
		26
	],
	"./guides/v3-staking-specification.mdx": [
		1194,
		26
	],
	"./guides/v3-upgrade-guide": [
		1195,
		27
	],
	"./guides/v3-upgrade-guide.mdx": [
		1195,
		27
	],
	"./guides/web3-provider-explained": [
		1196,
		28
	],
	"./guides/web3-provider-explained.mdx": [
		1196,
		28
	],
	"./guides/zrx-portal-faq": [
		1197,
		29
	],
	"./guides/zrx-portal-faq.mdx": [
		1197,
		29
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2295;
module.exports = webpackAsyncContext;